type Props = {
  children: any;
  modalDialogStyle?: any;
}
const RegularModal = (props: Props | any) => {
  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 z-10 bg-black bg-opacity-50 flex items-center justify-center">
      <div className={`${props.modalDialogStyle ? props.modalDialogStyle : "w-full"} p-3 bg-white rounded-3xl h-[80vh] overflow-y-auto m-3  hide-scrollbar`}>
        {props.children}
      </div>
    </div>
  );
};

export default RegularModal;
